export function getTicketLabel(label, showTicketSet, executionTicketSetLabel) {
    const needToShowTicketSet = showTicketSet && executionTicketSetLabel;
    const currentTicketLabel = `${label} ${
        needToShowTicketSet ? `(${executionTicketSetLabel})` : ''
    }`;
    return currentTicketLabel;
}

export default getTicketLabel;
